import Dexie from 'dexie';
import {
  DATABASE_VERSION,
  DATABASE_NAME,
  OFFLINE_DATABASE
} from '../../constants';

class DexieService {
  constructor() {
    const db = new Dexie(DATABASE_NAME);
    /**
            ++ Auto-incremented primary key
            & Unique index
            * Multi-entry index
            [key1+key2] Compound index or primary key
         */
    db.version(DATABASE_VERSION).stores({
      flatRate: '&id,code,*description, *section, *keywords',
      pricebookItems: '&id, type, description, updatedAt',
      pricebookCategories: '&id, displayName, updatedAt',
      companySetting: '&name',
      staticList: '&name',
      ticket:
        '&id,scheduledStartTime,scheduledEndTime,serviceId,ticketNumber,jobType, *locallyCreatedOn',
      assignment:
        '&id,assignmentStatusId,ticketObjectId,technicianId,startTime,endTime, *locallyCreatedOn',
      customer: '&id, *addressTypeId, *customerId, *addressType ',
      addressInfo: '&id, *addressTypeId, *customerId, *addressType',
      serviceAgreement: '&id, *serviceAgreementTypeId, name',
      priceTiers: '&id, *templateId, name',
      salesTax: '&id, *name, *locationCode, *keywords',
      notes: '&id, *ticketId, *locallyCreatedOn',
      timeCards:
        '&id, *ticketId, *startTime, *endTime, *techId, *locallyCreatedOn',
      invoice: '&id, *ticketId, invoiceNumber, locallyCreatedOn',
      items: '&id, *invoiceId, locallyCreatedOn',
      equipments: '&id, *serviceAddressId, locallyCreatedOn',
      preferences: '++id, &moduleId, value, displayName, startDate, endDate, imageCompressionType'
    });
    db.open();
    this.db = db;

    const offlineDatabase = new Dexie(OFFLINE_DATABASE);
    offlineDatabase.version(DATABASE_VERSION).stores({
      notes: '&id, *ticketId',
      timeCards: '&id, *ticketId, *startTime, *endTime, *techId',
      invoice: '&id, *ticketId',
      items: '&id, *invoiceId',
      equipments: '&id, *serviceAddressId',
      tickets: '&id, scheduledEndTime, scheduledStartTime',
      assignment: '&id, *technicianId, *ticketId, startTime, endTime',
      customer: '&id',
      fpForms: '&name',
      preferences: '++id, &moduleId, value, displayName, startDate, endDate, imageCompressionType'
    });
    offlineDatabase.open();
    this.offlineDatabase = offlineDatabase;
  }

  async clearStorage() {
    await this.db.delete();
    await this.offlineDatabase.delete();
    return true;
  }
}

export default new DexieService();
